import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CookieConsentBanner } from './CookieConsentBanner.js';
import { CookiePreferencesDialog } from './CookiePreferencesDialog.js';
/**
 * Mounts the banner and the preferences dialog. Renders nothing on the server and on the first
 * client render, so a prerendered page hydrates without mismatch (NFR-PERF-1); the consent UI
 * appears right after mount.
 */
export function CookieConsentRoot() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);
    if (!mounted)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(CookieConsentBanner, {}), _jsx(CookiePreferencesDialog, {})] }));
}
//# sourceMappingURL=CookieConsentRoot.js.map